(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('as400-messages', {
                parent: 'entity',
                url: '/as400-messages',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pharmaPortalApp.as400Messages.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/as400-messages/as400-messages.html',
                        controller: 'AS400MessagesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('as400Messages');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }
})();
